



































import { Component, Vue, Prop } from 'vue-property-decorator';

import { IPeriod } from '@/models/period';
import { IChartSerie } from '@/models/performance';
import PerformanceUtils from '@/utils/PerformanceUtils';

import SectionData from '@/componentsV2/organisms/SectionData/SectionData.vue';
import Trigger from '@/componentsV2/molecules/Trigger/Trigger.vue';
import SellCoinsCampaignListItem from '@/componentsV2/templates/SellCoinsCampaignListItem/SellCoinsCampaignListItem.vue';

import SellCoinsService from '@/api/SellCoinsService';
import { AnalyticsCardListItem } from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';
import BaseChart from '@/componentsV2/molecules/Chart/BaseChart.vue';
import { ApexOptions } from 'apexcharts';

export enum EYourEarningsGroupByLabel {
  ACCUMULATE = 'Accumulated',
  OVERTIME = 'Over Time'
}

@Component({
  components: {
    SectionData,
    Trigger,
    SellCoinsCampaignListItem,
    BaseChart
  }
})
export default class YourEarnings extends Vue {
  sellCoinsService = new SellCoinsService();

  @Prop({ default: false }) loading!: boolean;
  @Prop() earningsData!: IChartSerie[];
  @Prop() series!: IChartSerie[];
  @Prop({ required: true }) period!: IPeriod;
  @Prop({
    default: () => []
  })
  analyticsItems!: AnalyticsCardListItem[];

  get options(): ApexOptions {
    return {
      ...PerformanceUtils.chartOptions({
        colors: ['#3E24D6']
      }),
      tooltip: {
        custom: ({ dataPointIndex, seriesIndex }) => {
          const breakdown =
            this.earningsData &&
            this.earningsData.length > 0 &&
            this.earningsData[seriesIndex].data &&
            this.earningsData[seriesIndex].data[dataPointIndex];

          const num = (n: string | number) =>
            n.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

          if (!breakdown) {
            return '';
          }

          const startDate = new Date(this.earningsData[seriesIndex].data[0][0]);
          const finalDate = new Date(breakdown[0]);

          const formattedStartDate = startDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          });
          const formattedEndDate = finalDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          });

          const isAccumulated = seriesIndex === 0;
          const isNotFirstPoint = dataPointIndex !== 0;

          return `
              <div style="display: inline-flex; padding: 16px; flex-direction: column; justify-content: center; align-items: flex-start; gap: 12px; border-radius: 16px; background: #FFF; box-shadow: 0px 16px 40px 0px rgba(112, 144, 176, 0.20); min-width: 184px">
                <span style="color: #19191F; text-align: right; font-family: Inter; font-size: 14px; font-style: normal; font-weight: 600; line-height: normal;">
                  ${
                    isAccumulated && isNotFirstPoint
                      ? `${formattedStartDate} - `
                      : ''
                  }${formattedEndDate}
                </span>
                <div style="display: flex; justify-content: space-between; align-items: center; align-self: stretch;">
                  <span style="color: #19191F; text-align: right; font-family: Inter; font-size: 14px; font-style: normal; font-weight: 400; line-height: 150%;">
                    Your revenue
                  </span>
                  <span style="color: #19191F; text-align: right; font-family: Inter; font-size: 14px; font-style: normal; font-weight: 700; line-height: normal;">
                    $${num(breakdown[1] || 0)}
                  </span>
                </div>
              </div>
            `;
        }
      }
    };
  }

  search = {
    placeholder: 'Search by name or code',
    term: ''
  };

  get tPrefix() {
    return 'sellCoins.revenueReports.yourEarningsSection';
  }

  get configSection() {
    return {
      descriptionMaxWidth: '684px',
      padding: 0,
      titleFontSize: '20px',
      headerMarginBottom: '32px'
    };
  }

  get tAnalyticsInfoPrefix() {
    return `${this.tPrefix}.analytics.info`;
  }
}
